import { render } from "./marketinghistory.vue?vue&type=template&id=10cc5151"
import script from "./marketinghistory.vue?vue&type=script&lang=js"
export * from "./marketinghistory.vue?vue&type=script&lang=js"

import "./marketinghistory.vue?vue&type=style&index=0&id=10cc5151&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__